<template>
  <ejs-dialog
    ref="calendarDayFormDialog"
    id="calendar-days-form"
    class="dialog-karin"
    target="#dialogCalendarDays"
    :isModal="true"
    :visible="showing"
    :header="header"
    :width="width"
    :showCloseIcon="true"
    :close="onDialogClose"
    :open="onDialogOpen"
    z-index="1003"
  >
    <div class="col-lg-12 e-input-section">
      <div class="content-wrapper">
        <div class="card">
          <div class="card-header">
            {{ m_data.id }} - {{ m_data.description }} ({{
              m_data.isActive ? "Activo" : "Inactivo"
            }})
          </div>

          <div class="card-body">
            <div class="row">
              <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                <ejs-checkbox
                  label="Domingo"
                  :checked="m_data.sundayEnabled"
                  readonly="true"
                  disabled="true"
                ></ejs-checkbox>
              </div>
              <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                <ejs-checkbox
                  label="Lunes"
                  :checked="m_data.mondayEnabled"
                  readonly="readonly"
                  disabled="true"
                ></ejs-checkbox>
              </div>
              <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                <ejs-checkbox
                  label="Martes"
                  :checked="m_data.tuesdayEnabled"
                  readonly="true"
                  disabled="true"
                ></ejs-checkbox>
              </div>
              <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                <ejs-checkbox
                  label="Miércoles"
                  :checked="m_data.wednesdayEnabled"
                  readonly="true"
                  disabled="true"
                ></ejs-checkbox>
              </div>
              <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                <ejs-checkbox
                  label="Jueves"
                  :checked="m_data.thursdayEnabled"
                  readonly="true"
                  disabled="true"
                ></ejs-checkbox>
              </div>
              <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                <ejs-checkbox
                  label="Viernes"
                  :checked="m_data.fridayEnabled"
                  readonly="true"
                  disabled="true"
                ></ejs-checkbox>
              </div>
              <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                <ejs-checkbox
                  label="Sábado"
                  :checked="m_data.saturdayEnabled"
                  readonly="true"
                  disabled="true"
                ></ejs-checkbox>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div id="edit-overlay" v-show="isEditing"></div>
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 p-3">
            <div :style="customCalendarStyle">
              <ejs-calendar
                id="calendarDaysCal"
                @change="calendarChanged"
                @navigated="calendarNavigated"
                :renderDayCell="renderCalendar"
                ref="objCalendarDays"
              ></ejs-calendar>
            </div>
            <div class="card bg-light card-top-overlay">
              <div class="card-header">
                <span
                  class="badge badge-primary"
                  v-show="currentFormData.isCustomized"
                >
                  Calendario
                </span>
                {{ currentStringDate }}
                <div style="float: right;">
                  <div
                    class="e-btn-group e-outline edit-btn-group"
                    v-show="!isEditing"
                  >
                    <button
                      class="e-btn e-primary e-outline"
                      :disabled="addButtonDisabled"
                      @click="setAction('add')"
                    >
                      <span
                        class="e-btn-icon e-cal-icon e-icons e-add-new"
                      ></span>
                    </button>
                    <button
                      class="e-btn e-outline"
                      :disabled="editButtonDisabled"
                      @click="setAction('edit')"
                    >
                      <span class="e-btn-icon e-cal-icon e-icons e-edit"></span>
                    </button>
                    <button
                      class="e-btn e-warning e-outline"
                      :disabled="deleteButtonDisabled"
                      @click="setAction('delete')"
                    >
                      <span
                        class="e-btn-icon e-cal-icon e-icons e-delete"
                      ></span>
                    </button>
                  </div>
                </div>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-xs-12 col-sm-12 col-lg-6 col-md-6 ">
                    <div class="centered">
                      <ejs-switch
                        cssClass="align-middle"
                        id="isHoliDay"
                        @change="setHoliday"
                        :checked="currentFormData.isHolyDay"
                        :disabled="isFormReadOnly"
                      >
                      </ejs-switch>
                      <label
                        for="isHoliDay"
                        class="e-text align-middle switch-label"
                        >{{
                          currentFormData.isHolyDay ? "Festivo" : "No Festivo"
                        }}</label
                      >
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-12 col-lg-6 col-md-6 ">
                    <div class="centered">
                      <ejs-switch
                        cssClass="align-middle"
                        id="IsWorkingDay"
                        @change="setWorkingDay"
                        :checked="currentFormData.isWorkingDay"
                        :disabled="isFormReadOnly"
                      >
                      </ejs-switch>
                      <label
                        for="IsWorkingDay"
                        class="e-text align-middle switch-label"
                        >{{
                          currentFormData.isWorkingDay
                            ? "Laborable"
                            : "No Laborable"
                        }}</label
                      >
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-12" style="margin-top: 20px;">
                    <ejs-textbox
                      floatLabelType="Auto"
                      v-model="currentFormData.description"
                      :readonly="isFormReadOnly"
                      :cssClass="
                        hasError('description')
                          ? 'e-outline e-warning'
                          : 'e-outline'
                      "
                      placeholder="Descripción / Celebración"
                      @input="validateDescription()"
                      @blur="validateDescription()"
                    ></ejs-textbox>
                    <span
                      class="help e-text small"
                      :class="{ 'e-warning': hasError('description') }"
                      v-text="m_errors.description"
                    >
                    </span>
                  </div>
                  <div
                    id="hourGridContainer"
                    class="col-xs-12 col-sm-12 col-md-12 col-lg-12"
                    style=" margin-top:20px;"
                  >
                    <ejs-grid
                      id="customHourGrid"
                      ref="customHourGrid"
                      :dataSource="gridDataSource"
                      :editSettings="editSettings"
                      :toolbar="newToolbar"
                      :actionBegin="grid_ActionBegin"
                      :actionComplete="grid_ActionComplete"
                      :toolbarClick="hour_toolbarClick"
                      locale="es-CO"
                      width="100%"
                    >
                      <e-columns>
                        <e-column
                          field="id"
                          :visible="false"
                          headerText="Id"
                          :isPrimaryKey="true"
                        ></e-column>
                        <e-column
                          field="CustomDayId"
                          :visible="false"
                          headerText="Dia"
                        ></e-column>
                        <e-column
                          field="fromHour"
                          headerText="Hora Desde"
                          :width="120"
                          format="HH:mm"
                          editType="dropdownedit"
                          :edit="hourParams"
                          :validationRules="valHourRules"
                        ></e-column>
                        <e-column
                          field="toHour"
                          headerText="Hora Hasta"
                          :width="150"
                          format="HH:mm"
                          editType="dropdownedit"
                          :validationRules="valHourRules"
                          :edit="hourParams"
                        ></e-column>
                      </e-columns>
                    </ejs-grid>
                    <span
                      class="help e-text small"
                      :class="{ 'e-warning': hasError('horas') }"
                      v-text="m_errors.horas"
                    >
                    </span>
                  </div>
                </div>
                <div class="row pull-right">
                  <div class="col-xs-12 col-sm-12 ">
                    <div class="e-btn-group">
                      <ejs-button
                        @click.native="validateForm()"
                        :isPrimary="true"
                        iconCss="e-icons icon-save inline-command"
                        cssClass="e-flat e-noback"
                        v-if="showSaveButton"
                        >Grabar</ejs-button
                      >
                      <ejs-button
                        @click.native="getDeleteConfirmation()"
                        :isDanger="true"
                        iconCss="e-icons icon-trash inline-command"
                        cssClass="e-flat e-danger e-noback"
                        v-if="showDeleteButton"
                        >Eliminar</ejs-button
                      >
                      <ejs-button
                        @click.native="cancelEdition()"
                        iconCss="e-icons icon-cancel inline-command"
                        cssClass="e-flat e-noback"
                        v-if="showCancelButton"
                        >Cancelar</ejs-button
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row pull-right">
          <div class="col-xs-12 col-sm-12 ">
            <div class="e-btn-group">
              <ejs-button
                @click.native="close()"
                iconCss="e-icons icon-cancel inline-command"
                cssClass="e-flat e-noback"
                >Salir</ejs-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </ejs-dialog>
</template>

<script>
import Vue from "vue";
/*import { object, string, number, yup, when } from "yup";*/

import { FormActionEnum } from "../../services/enums.js";
import PermissionMixin from "../../mixins/PermissionMixin";
import ToastMixin from "../../mixins/ToastMixin";
import CultureMixin from "../../mixins/CultureMixin";

/* Plugins de Syncfusion */
import { ButtonPlugin } from "@syncfusion/ej2-vue-buttons";
Vue.use(ButtonPlugin);

import { SwitchPlugin } from "@syncfusion/ej2-vue-buttons";
Vue.use(SwitchPlugin);

import { NumericTextBoxPlugin } from "@syncfusion/ej2-vue-inputs";
Vue.use(NumericTextBoxPlugin);

import { DialogPlugin } from "@syncfusion/ej2-vue-popups";
Vue.use(DialogPlugin);

import { CheckBoxPlugin } from "@syncfusion/ej2-vue-buttons";
Vue.use(CheckBoxPlugin);

import { GridPlugin, Page, Edit, Toolbar } from "@syncfusion/ej2-vue-grids";
Vue.use(GridPlugin);

import { CalendarPlugin } from "@syncfusion/ej2-vue-calendars";
Vue.use(CalendarPlugin);

import { TextBoxPlugin } from "@syncfusion/ej2-vue-inputs";
Vue.use(TextBoxPlugin);

import { DateTimePickerPlugin } from "@syncfusion/ej2-vue-calendars";
Vue.use(DateTimePickerPlugin);

import { Query } from "@syncfusion/ej2-data";

/* Utilidades Syncfusion */
import { DialogUtility } from "@syncfusion/ej2-popups";
import {
  createSpinner,
  showSpinner,
  hideSpinner
} from "@syncfusion/ej2-popups";

/* Validación con YUP*/
import * as Yup from "yup";
import { es } from "yup-locales";
import { setLocale } from "yup";
setLocale(es);

export default Vue.extend({
  mixins: [PermissionMixin, ToastMixin, CultureMixin],
  computed: {
    customCalendarStyle() {
      return this.isMobile
        ? "margin: 10px;"
        : "float:left; margin: 10px; margin-top:0;";
    },
    showCancelButton() {
      return (
        this.calendarAction !== FormActionEnum.VIEW && this.showActionButtons
      );
    },
    showSaveButton() {
      return (
        (this.calendarAction === FormActionEnum.ADD ||
          this.calendarAction === FormActionEnum.EDIT) &&
        this.showActionButtons
      );
    },
    showDeleteButton() {
      return (
        this.calendarAction == FormActionEnum.DELETE && this.showActionButtons
      );
    },
    customClass() {
      return {
        "dialog-karin": true,
        "dialog-edit":
          this.formAction == FormActionEnum.ADD ||
          this.formAction == FormActionEnum.EDIT,
        "dialog-view": this.formAction == FormActionEnum.VIEW,
        "dialog-delete": this.formAction == FormActionEnum.DELETE
      };
    },
    marginTopId() {
      var strMT = "auto;";

      switch (this.formAction) {
        case FormActionEnum.ADD:
          strMT = "margin-top: 20px;";
          break;
        default:
          strMT = "margin-top: 0;";
          break;
      }
      return strMT;
    },
    isFormReadOnly() {
      var ret = false;

      switch (this.calendarAction) {
        case FormActionEnum.ADD:
          break;
        case FormActionEnum.EDIT:
          break;
        case FormActionEnum.VIEW:
          ret = true;
          break;
        case FormActionEnum.DELETE:
          ret = true;
          break;
      }
      return ret;
    },
    header() {
      if (this.formAction === FormActionEnum.EDIT) {
        return "Gestionar Fechas Personalizadas";
      }
      return "";
    },
    canDelete() {
      if (!this.hasPermission("CanDelete")) {
        return false;
      }
      return true;
    },
    gridDataSource() {
      var hasData = !!this.currentFormData.calendarCustomHours;

      if (!hasData) {
        return [];
      }

      var currentRows = this.currentFormData.calendarCustomHours.filter(
        x => x.removed == false || x.removed == undefined
      );

      hasData = !!currentRows;
      if (hasData) {
        var newArray = JSON.parse(JSON.stringify(currentRows));
        newArray.sort((a, b) => {
          if (a.fromHour > b.fromHour) {
            return 1;
          }
          if (a.fromHour < b.fromHour) {
            return -1;
          }
          return 0;
        });
        return newArray;
      } else {
        return [];
      }
    },
    currentDayWeekData() {
      var hasData = !!this.m_data.calendarWeekHours;

      if (!hasData) {
        return [];
      }

      //return this.m_data.calendarWeekHours;

      var currentRows = this.m_data.calendarWeekHours.filter(
        x =>
          x.weekDayId == this.currentDay &&
          (x.removed == false || x.removed == undefined)
      );

      hasData = !!currentRows;
      if (hasData) {
        var newArray = JSON.parse(JSON.stringify(currentRows));
        newArray.sort((a, b) => {
          if (a.fromHour > b.fromHour) {
            return 1;
          }
          if (a.fromHour < b.fromHour) {
            return -1;
          }
          return 0;
        });
        return newArray;
      } else {
        return [];
      }
    },
    currentYear() {
      var d = new Date();
      var year = d.getFullYear();
      return year;
    },
    today() {
      var d = new Date();
      d.setHours(0);
      d.setMinutes(0);
      d.setSeconds(0);
      d.setMilliseconds(0);
      return d;
    },
    isCurrentDayWorkingDay() {
      var ret = false;
      switch (this.currentDay) {
        case 0:
          ret = this.m_data.sundayEnabled ?? false;
          break;
        case 1:
          ret = this.m_data.mondayEnabled ?? false;
          break;
        case 2:
          ret = this.m_data.tuesdayEnabled ?? false;
          break;
        case 3:
          ret = this.m_data.wednesdayEnabled ?? false;
          break;
        case 4:
          ret = this.m_data.thursdayEnabled ?? false;
          break;
        case 5:
          ret = this.m_data.fridayEnabled ?? false;
          break;
        case 6:
          ret = this.m_data.saturdayEnabled ?? false;
          break;
        default:
          ret = false;
          break;
      }
      return ret;
    },
    isEditing() {
      return (
        this.calendarAction != FormActionEnum.VIEW &&
        this.calendarAction != FormActionEnum.LIST
      );
    },
    showActionButtons() {
      return !this.isInGridEdition;
    },
    addButtonDisabled() {
      var canCreate = this.hasPermission("CanCreate") ?? false;
      return !(canCreate && this.currentFormData.isCustomized == false);
    },
    editButtonDisabled() {      
      var canEdit = this.hasPermission("CanEdit") ?? false;
      var disable = !(canEdit && this.currentFormData.isCustomized == true);
      if (this.currentDate == null) return true;

      if (!disable) {
        disable = this.currentDate < this.today;
      }

      return disable;
    },
    deleteButtonDisabled() {
      var canDelete = this.hasPermission("CanDelete") ?? false;

      var disable = !(canDelete && this.currentFormData.isCustomized == true);
      if (!disable) {
        disable = this.currentDate < this.today;
      }
      return disable;
    }
    // newToolbar() {
    //   return "['Add', 'Edit', 'Delete', 'Update', 'Cancel']";
    //   // if (this.isFormReadOnly) {
    //   // } else {
    //   //   return [];
    //   // }
    // }
  },
  data() {
    return {
      /* Datos del Componente*/
      isValid: false,
      isMounted: false,
      calendarSchema: {},
      weekHoursSchema: {},
      m_errors: {},
      m_data: {},
      hourFormat: /^([0-1]?\d|2[0-3])(?::([0-5]?\d))(?::([0-5]?\d))?$/,
      fields: { text: "name", value: "id" },
      newToolbar: ["Add", "Edit", "Delete", "Update", "Cancel"],

      currentDay: 0,
      currentFormData: {},
      hourList: [],
      editSettings: {
        allowEditing: true,
        allowAdding: true,
        allowDeleting: true
      },
      hourParams: {
        params: {
          allowFiltering: true,
          dataSource: this.getHourList(),
          fields: { text: "value", value: "value" },
          query: new Query(),
          actionComplete: () => false
        }
      },
      weekDays: [
        { id: 0, name: "Domingo" },
        { id: 1, name: "Lunes" },
        { id: 2, name: "Martes" },
        { id: 3, name: "Miércoles" },
        { id: 4, name: "Jueves" },
        { id: 5, name: "Viernes" },
        { id: 6, name: "Sábado" }
      ],
      valHourRules: {
        required: [true, "Campo Requerido"],
        minLength: [
          args => {
            return args["value"].length >= 5;
          },
          "Formato Requerido HH:mm"
        ]
      },
      /* Datos del Dialogo de Syncfusion*/
      isModal: true,
      /*isOpen: false,*/
      target: document.getElementById("dialog"),
      width: this.isMobile ? "500px" : "70%",
      /*Datos de la Edición de Calendarios*/
      deleteDialog: null,
      currentDate: null,
      currentStringDate: "No Seleccionado",
      celebration: "",
      selectedDay: {},
      selectedYear: 0,
      isInGridEdition: false,
      calendarAction: FormActionEnum.VIEW
    };
  },
  provide: {
    grid: [Page, Edit, Toolbar]
  },
  created() {
    /* Obtener los datos de las zonas desde el  */
    /* this.formAction = FormActionEnum.LIST;*/
  },
  updated() {
    // var edit = this.isEditing;
    // console.log("Deshabilitar?", !edit);
    // this.enableGridToolbar(!edit);
  },
  async mounted() {
    try {
      //crear el spinner de loading

      createSpinner({
        /* target: document.getElementById("calendar-form")*/
        target: this.$refs.calendarDayFormDialog.$el
      });

      this.buildYupSchema();
      this.isMounted = true;
    } catch (error) {
      console.log(error);
    }
  },
  methods: {
    setAction(action) {
      switch (action) {
        case "add":
          this.calendarAction = FormActionEnum.ADD;
          this.enableGridToolbar(true);
          break;
        case "edit":
          this.calendarAction = FormActionEnum.EDIT;
          this.enableGridToolbar(true);
          break;
        case "delete":
          this.calendarAction = FormActionEnum.DELETE;
          this.enableGridToolbar(false);
          break;
        default:
          this.calendarAction = FormActionEnum.VIEW;
          this.enableGridToolbar(false);
          break;
      }
    },
    hour_toolbarClick(args) {
      if (this.isFormReadOnly) args.cancel = true;
    },
    disableItem(el, enable) {
      var parent = el.parentElement;
      if (enable) {
        if (parent.classList.contains("e-overlay"))
          parent.classList.remove("e-overlay");
      } else {
        if (!parent.classList.contains("e-overlay"))
          parent.classList.add("e-overlay");
      }
    },
    enableGridToolbar(enable) {
      try {
        var el = document.getElementById("customHourGrid_toolbarItems");
        var display = "";
        if (!enable) display = "display: none;";
        if (el != null) {
          el.style = "height: auto; width: auto; overflow: hidden;" + display;
        }
        /*
        var el = document.getElementById("customHourGrid_add");
        if (el != null) {
          this.disableItem(el, enable);
        }

        el = document.getElementById("customHourGrid_edit");
        if (el != null) {
          this.disableItem(el, enable);
        }

        el = document.getElementById("customHourGrid_delete");
        if (el != null) {
          this.disableItem(el, enable);
        }
        this.$forceUpdate();
        */

        /*
        this.$refs.customHourGrid.ej2Instances.toolbarModule.enableItems(
          [
            "customHourGrid_add",
            "customHourGrid_edit",
            "customHourGrid_delete"
          ],
          enable
        ); //Enable toolbar items.
        */
        //customHourGrid
      } catch (error) {
        console.log(error);
      }
    },
    getHourList() {
      var items = [];
      for (var i = 0; i <= 23; i++) {
        var hour = i.toString().padStart(2, 0);
        items.push({ value: hour + ":00" });
        items.push({ value: hour + ":15" });
        items.push({ value: hour + ":30" });
        items.push({ value: hour + ":45" });
        if (i == 23) {
          items.push({ value: hour + ":59" });
        }
      }
      return items;
    },
    validateHours(from, to, id) {
      var hFrom = from.split(":");
      var hTo = to.split(":");
      var intHourFrom = parseInt(hFrom[0]);
      var intHourTo = parseInt(hTo[0]);
      var intMinuteFrom = parseInt(hFrom[1]);
      var intMinuteTo = parseInt(hTo[1]);
      var valid = true;

      if (
        isNaN(intHourFrom) ||
        isNaN(intHourTo) ||
        isNaN(intMinuteFrom) ||
        isNaN(intMinuteTo)
      )
        return false;

      if (intHourFrom == intHourTo && intMinuteFrom >= intMinuteTo) {
        valid = false;
      } else if (intHourFrom > intHourTo) {
        valid = false;
      }

      if (valid){
        let array = this.currentFormData.calendarCustomHours.filter(x => (x.isNew == undefined || x.isNew == null || x.isNew == false) && x.id != id);
        array.forEach(item =>{
          var itemFrom = item.fromHour.split(":");
          var itemTo = item.toHour.split(":");
          var itemHourFrom = parseInt(itemFrom[0]);
          var itemHourTo = parseInt(itemTo[0]);
          var itemMinuteFrom = parseInt(itemFrom[1]);
          var itemMinuteTo = parseInt(itemTo[1]);

          if ((intHourFrom < itemHourFrom || (intHourFrom == itemHourFrom &&  intMinuteFrom <= itemMinuteFrom)) && 
              (intHourTo > itemHourFrom || (intHourTo == itemHourFrom && intMinuteTo >= itemMinuteFrom))){
            valid = false;
          }

          if ((intHourFrom < itemHourTo || (intHourFrom == itemHourTo && intMinuteFrom <= itemMinuteTo)) && 
              (intHourTo > itemHourTo || (intHourTo == itemHourTo && intMinuteTo >= itemMinuteTo))){
            valid = false;
          }

          if ((intHourFrom < itemHourFrom || (intHourFrom == itemHourFrom && intMinuteFrom < itemMinuteFrom)) && 
              (intHourTo > itemHourTo || (intHourTo == itemHourTo && intMinuteTo > itemMinuteTo))){
            valid = false;
          }
          
          if ((itemHourFrom < intHourFrom || (itemHourFrom == intHourFrom && itemMinuteFrom < intMinuteFrom)) && 
              (itemHourTo > intHourTo || (itemHourTo == intHourTo && itemMinuteTo > intMinuteTo))){
            valid = false;
          }
        });
      }

      return valid;
    },
    async onDialogOpen() {
      this.m_data = Object.assign({}, this.formData);
      var year = this.currentYear;
      this.selectedYear = year;
      this.setCurrentDate(new Date());
      await this.loadYearData(year);
      this.calendarAction = FormActionEnum.VIEW;
    },
    setCurrentDate(date) {
      date.setHours(0);
      date.setMinutes(0);
      date.setSeconds(0);
      this.currentDate = date;
    },
    onDialogClose() {
      this.clearErrors();
      this.calendarAction = FormActionEnum.VIEW;
      this.currentDay = null;
      this.currentFormData = {};
      // if (args) args.cancel = true;
      this.$emit("formClosed");
    },
    close() {
      this.$emit("formClosed");
      /* forzar el cierre del componente */
      /* this.$refs.calendarDayFormDialog.close(); */
    },
    getAlertDialog(title, content) {
      let dialog = DialogUtility.alert({
        title: title,
        zindex: 1010,
        content: content,
        /* okButton: { text: "OK", click: okClick.bind(this) }, */
        /* cancelButton: {  text: 'Cancel', click: cancelClick.bind(this)},*/
        showCloseIcon: true,
        closeOnEscape: true,
        animationSettings: { effect: "Zoom" }
      });
      return dialog;
    },
    showSpinner() {
      showSpinner(this.$refs.calendarDayFormDialog.$el);
    },
    hideSpinner() {
      hideSpinner(this.$refs.calendarDayFormDialog.$el);
    },
    clearErrors() {
      this.m_errors = {};
    },
    grid_ActionComplete(args) {
      if (args.name == "actionComplete" && args.requestType == "add") {
        if (!args.cancel) this.isInGridEdition = true;
      }
      if (args.name == "actionComplete" && args.requestType == "beginEdit") {
        if (!args.cancel) this.isInGridEdition = true;
      }
      if (args.name == "actionComplete" && args.requestType == "save") {
        if (!args.cancel) this.isInGridEdition = false;
      }
      if (args.name == "actionComplete" && args.requestType == "cancel") {
        if (!args.cancel) this.isInGridEdition = false;
      }
    },
    grid_ActionBegin(args) {
      if (
        args.requestType == "save" &&
        (args.action == "add" || args.action == "edit")
      ) {
        var isValid = this.validateHours(args.data.fromHour, args.data.toHour, args.data.id);
        if (!isValid) {
          this.showToast(
            "Error",
            "Los datos ingresados no son validos, por favor verifica los valores de las horas",
            2000
          );
          args.cancel = true;
        }

        if (!args.cancel) {
          this.saveTempDate(args.data);
        }
      } else if (args.requestType == "delete") {
        //En el delete viene en un arreglo.
        this.deleteTempDate(args.data[0]);
      }
    },
    // grid_ActionComplete(args) {
    //   if (args.requestType == "refresh") {
    //     console.log(this.isEditing);
    //     this.enableGridToolbar(this.isEditing);
    //   }
    // },
    findCalendarHourArrayIndex(data) {
      var indice = -1;

      var len = this.currentFormData.calendarCustomHours.length;
      for (var i = 0; i < len; i++) {
        var el = this.currentFormData.calendarCustomHours[i];
        var igualito = this.isEqual(el, data);
        if (igualito) {
          indice = i;
          break;
        }
      }
      // this.m_data.calendarWeekHours.forEach((el, idx) => {
      //   var igualito = this.isEqual(el, data);
      //   if (igualito) {
      //     indice = idx;
      //   }
      // });
      return indice;
    },
    findCalendarHourArrayIndexById(data) {
      var indice = -1;
      var len = this.currentFormData.calendarCustomHours.length;

      for (var i = 0; i <= len; i++) {
        var el = this.currentFormData.calendarCustomHours[i];

        var igualito = el.id == data.id && el.id != undefined;

        if (igualito) {
          indice = i;
          break;
        }
      }

      // this.m_data.calendarWeekHours.forEach((el, idx) => {
      //   var igualito = el.id == data.id && el.id != undefined;
      //   if (igualito) {
      //     indice = idx;
      //   }
      // });

      return indice;
    },
    isEqual(s, d) {
      // console.log("source", s);
      // console.log("Destination", d);
      var ret = false;

      var sfh = s.fromHour.substring(0, 5);
      var dfh = d.fromHour.substring(0, 5);
      var sth = s.toHour.substring(0, 5);
      var dth = d.toHour.substring(0, 5);

      var str1 = `${s.id}|${s.customDayId}|${sfh}|${sth}`;
      var str2 = `${d.id}|${d.customDayId}|${dfh}|${dth}`;

      ret = str1 == str2;

      return ret;
    },
    mapDataToNewData(data) {
      var newData = JSON.parse(JSON.stringify(data));
      if (newData.id == undefined || newData.id == 0) {
        newData.isNew = true;
        newData.customDayId = this.currentFormData.id;
      } else {
        newData.isNew = false;
      }

      return newData;
    },
    deleteTempDate(data) {
      var newData = this.mapDataToNewData(data);
      // var index = this.findweekHourArrayIndex(newData);
      var index = -1;
      if (newData.isNew) {
        index = this.findCalendarHourArrayIndex(newData);
      } else {
        index = this.findCalendarHourArrayIndexById(newData);
      }

      if (newData.isNew) {
        if (index >= 0)
          this.$delete(this.currentFormData.calendarCustomHours, index);
      } else {
        if (index >= 0) {
          newData.removed = true;
          this.$set(this.currentFormData.calendarCustomHours, index, newData);
        }
      }
    },
    saveTempDate(data) {
      var newData = this.mapDataToNewData(data);

      var index = -1;
      if (newData.isNew) {
        index = this.findCalendarHourArrayIndex(newData);
      } else {
        index = this.findCalendarHourArrayIndexById(newData);
      }

      if (index >= 0) {
        this.$set(this.currentFormData.calendarCustomHours, index, newData);
      } else {
        this.currentFormData.calendarCustomHours.push(newData);
      }
    },
    getDayName(day) {
      var semana = [
        "Domingo",
        "Lunes",
        "Martes",
        "Miércoles",
        "Jueves",
        "Viernes",
        "Sábado"
      ];
      return semana[day];
    },
    async saveData() {
      try {
        var id = this.m_data.id;
        var day = this.currentFormData;
        this.showSpinner();
        switch (this.calendarAction) {
          case FormActionEnum.VIEW:
            this.showToast(
              "No habilitado",
              "Modo consulta, nada para grabar!",
              2000
            );
            break;
          case FormActionEnum.ADD:
            this.m_data.isActive = true;

            await this.$store.dispatch("calendars/createCustomDay", {
              id,
              day
            });

            this.showToast("Confirmación", "Registro Creado!", 2000);
            break;
          case FormActionEnum.EDIT:
            await this.$store.dispatch("calendars/updateCustomDay", {
              id,
              day
            });
            this.showToast("Confirmación", "Registro Actualizado", 2000);
            break;
          case FormActionEnum.DELETE:
            await this.$store.dispatch("calendars/deleteCustomDay", {
              id,
              day
            });

            this.deleteDialog.hide();
            this.showToast("Confirmación", "Registro Eliminado", 2000);
            break;
        }
        //await this.$store.dispatch("calendars/getCalendars");
        await this.loadYearData(this.selectedYear);
        /* esperar medio segundo antes de cerrar */
        setTimeout(() => {
          this.hideSpinner();
          this.cancelEdition();
        }, 500);
      } catch (error) {
        this.hideSpinner();
        this.showToast(
          "Error!",
          "Ocurrió un error al ejecutar la operación",
          2000
        );
      }
    },
    cancelEdition() {
      this.setAction("view");
      this.reactToChange();
    },
    getDeleteConfirmation() {
      this.deleteDialog = DialogUtility.confirm({
        zindex: 1050,
        title: "Eliminar Fecha Personalizada",
        content: `Confirma que desea eliminar la fecha actual?: ${this.currentFormData.description}`,
        okButton: {
          text: "Eliminar",
          click: this.saveData,
          isPrimary: true
        },

        cancelButton: { text: "Cancelar" },
        showCloseIcon: false,
        closeOnEscape: false,
        animationSettings: { effect: "Zoom" }
      });
      this.deleteDialog.show();
    },
    buildYupSchema() {
      /*Hack para esLint*/

      this.calendarSchema = Yup.object().shape({
        isNew: Yup.boolean(),
        description: Yup.string()
          .required()
          .max(50)
          .label("Descripción"),
        calendarWeekHours: Yup.array()
          .min(1)
          .label("Horario Laboral")
      });

      var hourRegEx = this.hourFormat;
      this.weekHoursSchema = Yup.object().shape({
        isNew: Yup.boolean(),
        calendarId: Yup.number().when("isNew", {
          is: true,
          then: Yup.number().min(1),
          otherwise: Yup.number()
        }),
        CustomDayId: Yup.number()
          .required()
          .min(0)
          .max(6)
          .label("Día de la Semana"),
        fromHour: Yup.string()
          .matches(hourRegEx, "El formato de la hora no es válido")
          .label("Hora Desde"),
        toHour: Yup.string()
          .matches(hourRegEx, "El formato de la hora no es válido")
          .label("Hora Hasta")
      });
    },
    hasError(field, index) {
      if (index != undefined) field = field + "_" + index;
      return !!this.m_errors[field];
    },
    async validateField(field, index) {
      var errorName = field;
      if (index != undefined) errorName = errorName + "_" + index;
      Vue.set(this.m_errors, errorName, "");

      if (this.isFormReadOnly) return;

      this.calendarSchema.validateAt(field, this.currentFormData).catch(err => {
        var customPath = err.path;
        if (index != undefined) customPath = customPath + "_" + index;
        Vue.set(this.m_errors, customPath, err.message);
      });
    },
    async validateForm() {
      this.isValid = false;

      try {
        await this.calendarSchema.validate(this.currentFormData, {
          abortEarly: false
        });

        //validar que no se sobrelapen
        // for (var i = 0; i <= this.calendarCustomHours.length; i++) {

        // }

        this.m_errors = [];
        /*Grabar los datos*/
        var valid = await this.validateData();
        if (valid) {
          await this.saveData();
        }
      } catch (error) {
        var hasInner = !!error.inner;
        if (hasInner) {
          error.inner.forEach(error => {
            Vue.set(this.m_errors, error.path, error.message);
            //this.m_errors[error.path] = error.message;
          });
        } else {
          console.log(error);
        }
      }
    },
    async validateData() {
      // await this.$store.dispatch("calendars/getCalendars");
      // var listCalendar = this.$store.getters["calendars/allCalendars"];

      var id = this.m_data.id;
      var year = this.selectedYear;
      await this.$store.dispatch("calendars/getCalendarDates", { id, year });
      var listCalendar = JSON.parse(
        JSON.stringify(this.$store.getters["calendars/allcalendarDates"])
      );

      var listado = listCalendar.filter(u => u.id !== this.currentFormData.id);

      if (listado.find(element => element.date === this.currentFormData.date)) {
        this.showToast(
          "Invalido!",
          `Ya existe una fecha previamente registrada par el mismo dia ${this.m_data.date}`,
          2000
        );
        return false;
      }

      var hasHours = !!this.currentFormData.calendarCustomHours;

      var ErrorHoras = {
        inner: [
          {
            path: "horas",
            message: "No se puede grabar el día laboral sin horas definidas."
          }
        ]
      };

      if (!hasHours) {
        if (this.currentFormData.isWorkingDay) {
          throw ErrorHoras;
        }
      } else {
        var countNotRemoved = 0;
        for (
          var i = 0;
          i < this.currentFormData.calendarCustomHours.length;
          i++
        ) {
          var el = this.currentFormData.calendarCustomHours[i];
          if (!el.removed) countNotRemoved++;
        }

        if (countNotRemoved == 0 && this.currentFormData.isWorkingDay) {
          throw ErrorHoras;
        }
      }

      //Vue.set(this.m_errors, error.path, error.message);

      return true;
    },
    /* Métodos y Eventos del Calendario*/
    async validateDescription() {
      if (this.isFormReadOnly) return;
      var validationSchema = Yup.object().shape({
        isNew: Yup.boolean(),
        description: Yup.string()
          .required()
          .max(50)
          .label("Fecha especial")
      });

      Vue.set(this.m_errors, "description", "");
      var hasErrors = false;

      validationSchema
        .validateAt("description", this.currentFormData)
        .catch(err => {
          Vue.set(this.m_errors, err.path, err.message);
        });
      if (hasErrors) return false;

      var pattern = /[/,:;'{}\x22\\]/;
      var strData = this.currentFormData.description;
      //var regEx = new RegExp(pattern);
      var hasSpecial = strData.match(pattern) ? true : false;
      if (hasSpecial) {
        Vue.set(
          this.m_errors,
          "description",
          "La descripción tiene caracteres no permitidos"
        );
        // this.showToast(

        //   "No se puede grabar, la descripción tiene caracteres no permitidos"
        // );
        return false;
      }

      return true;
    },
    async calendarNavigated(args) {
      var oldYear = this.selectedYear;
      var newYear = oldYear;
      if (args.name == "navigated") {
        var date = args.date;
        newYear = date.getFullYear();
        oldYear = this.selectedYear;
        this.setCurrentDate(date);
        this.$refs.objCalendarDays.ej2Instances.value = date;
        this.reactToChange();

        if (args.view == "Month") {
          if (oldYear != newYear) {
            try {
              this.$parent.showLoading();

              await this.loadYearData(newYear);

              this.$parent.hideLoading(500);
            } catch (error) {
              this.$parent.hideLoading(500);
              this.showToast("error", error, 2000);
            }
          }
        }
      }
    },
    calendarChanged(args) {
      this.setCurrentDate(new Date(args.value));
      //this.currentDate = new Date(args.value);
      this.isInGridEdition = false;
      this.reactToChange();
    },
    initFormData() {
      var currentDate = {
        id: 0,
        calendarId: this.m_data.id,
        description: "",
        date: this.currentDate,
        isHolyDay: true,
        isWorkingDay: false,
        isCustomized: false,
        calendarCustomHours: []
      };
      this.currentFormData = currentDate;
    },
    setHoliday(args) {
      this.currentFormData.isHolyDay = args.checked ?? false;
    },
    setWorkingDay(args) {
      this.currentFormData.isWorkingDay = args.checked ?? false;
    },
    getcurrentDayData(date) {
      var currentDate = {
        id: 0,
        calendarId: this.m_data.id,
        description: "",
        date: date,
        isHolyDay: true,
        isWorkingDay: false,
        isCustomized: false,
        isFound: false,
        calendarCustomHours: []
      };

      var existsInCalendar = this.findCalendarDate(date);
      var hasDate = !!existsInCalendar;
      //Si existe la fecha entonces es festivo o personalizado.
      if (hasDate) {
        currentDate.id = existsInCalendar.id;
        currentDate.calendarId = existsInCalendar.calendarId;
        currentDate.description = existsInCalendar.description;
        currentDate.date = existsInCalendar.date;
        currentDate.isHolyDay = existsInCalendar.isHolyDay;
        currentDate.isWorkingDay = existsInCalendar.isWorkingDay;
        currentDate.isCustomized = existsInCalendar.isCustomized;

        currentDate.calendarCustomHours = existsInCalendar.calendarCustomHours;
        if (!currentDate.isCustomized) {
          //currentDate.isWorkingDay = this.isCurrentDayWorkingDay;
          currentDate.calendarCustomHours = this.getHoursFromWeekData();
        }
      } //Si no existe la fecha entonces es dia normal y se marca desde el holiday.
      else {
        currentDate.isHolyDay = false;
        currentDate.isWorkingDay = this.isCurrentDayWorkingDay;
        currentDate.isCustomized = false;
        currentDate.calendarCustomHours = this.getHoursFromWeekData();
      }
      this.m_errors = [];
      this.currentFormData = currentDate;
      this.enableGridToolbar(false);
    },
    getHoursFromWeekData() {
      var hours = [];
      this.currentDayWeekData.forEach(x => {
        var customHour = {
          id: 0,
          customDayId: 0,
          fromHour: x.fromHour,
          toHour: x.toHour,
          removed: false
        };
        hours.push(customHour);
      });
      return hours;
    },
    reactToChange() {
      const options = {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric"
      };

      this.currentStringDate = this.currentDate.toLocaleDateString(
        "es-CO",
        options
      );
      this.currentDay = this.currentDate.getDay();

      //cargar los datos del dia actual
      this.getcurrentDayData(this.currentDate);
    },
    renderCalendar(args) {
      //validar si los dias del calendario están marcados como festivos.
      //var stringDate = args.date.toISOString();
      //console.log(args);
      //console.log(args.element.classList);

      if (args.element.classList.value.includes("e-other-month")) {
        args.isDisabled = true;
        //args.element.classList.add("e-month-hide");
      }

      var hasDay = this.findCalendarDate(args.date);
      if (hasDay != null) {
        if (hasDay.isCustomized) {
          args.element.classList.add("e-highlightcustom");
        } else {
          if (hasDay.isHolyDay && !hasDay.isWorkingDay) {
            args.element.classList.add("e-highlightspecial");
          }

          if (!hasDay.isHolyDay && !hasDay.isWorkingDay) {
            args.element.classList.add("e-highlightspecial");
          }
        }
      } else if (args.date.getDay() === 0 || args.date.getDay() === 6) {
        // To highlight the week end of every month
        args.element.classList.add("e-highlightweekend");
      }
    },
    findCalendarDate(date) {
      try {
        var dateSearched = date.toISOString();
        var valSearched = dateSearched.substring(0, 10);
        /*
        var dateNew = Date(date);
        console.log(dateNew.toisoString());
        */
        if (this.yearDates == undefined) return null;

        var dateFound = this.yearDates.find(el => {
          var yearDate = el.date;
          var yearSearch = yearDate.substring(0, 10);
          return yearSearch == valSearched;
        });

        return dateFound;
        // if (dateFound != null) {
        //   return "Encontré la fecha: " + JSON.stringify(dateFound);
        // }
      } catch (error) {
        console.log(error);
      }

      return "";
    },
    async loadYearData(year) {
      this.selectedYear = year;
      var id = this.m_data.id;
      await this.$store.dispatch("calendars/getCalendarDates", { id, year });
      this.yearDates = JSON.parse(
        JSON.stringify(this.$store.getters["calendars/allcalendarDates"])
      );
      this.reactToChange();
      this.$refs.objCalendarDays.ej2Instances.refresh();
    }
  },

  props: {
    /** Whether the dialog is currently showing */
    showing: {
      type: Boolean,
      required: true,
      default: false
    },
    formAction: {
      type: Number,
      required: true,
      default: 0
    },
    isMobile: {
      type: Boolean,
      required: true,
      default: false
    },
    formData: {
      type: Object,
      required: false,
      default() {
        return { id: 0, name: "", isActive: false };
      }
    }
  }
});
</script>

<style>
@import url(../../../node_modules/@syncfusion/ej2-base/styles/fabric.css);
@import url(../../../node_modules/@syncfusion/ej2-vue-buttons/styles/fabric.css);
@import url(../../../node_modules/@syncfusion/ej2-vue-calendars/styles/fabric.css);
@import url(../form-icons.css);

.disablegrid {
  pointer-events: none;
  opacity: 0.4;
}

.disabled-wrapper {
  cursor: not-allowed;
}

.dialog-karin.e-dialog .e-dlg-header {
  color: #0078d6;
  font-size: 20px;
  font-weight: normal;
}

.content-wrapper div.row {
  padding: 5px 0px;
}

.switch-label {
  padding: 0px 0px 0px 20px;
  margin: auto;
  cursor: pointer;
}

.e-save.e-icons:before,
.e-save.e-icons:before {
  content: "\e609";
}

@media only screen and (max-width: 480px) {
  .content-wrapper {
    width: 92%;
  }
  .e-input-section .col-xs-6,
  .e-input-section .col-xs-4,
  .e-input-section .col-xs-12 {
    padding: 10px 5px;
    width: 100%;
  }
  .content-wrapper div.row {
    padding: 0px;
  }
}

div.centered {
  margin: 0;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}

.e-highlightweekend {
  background-color: #cccccc;
}

.e-calendar .e-content td.e-selected {
  background-color: #0078d6;
}

.e-highlightcustom {
  background-color: rosybrown;
  color: white !important;
}

.e-highlightcustom .e-day {
  color: white !important;
}

.e-cell.e-highlightcustom.e-today.e-selected .e-day {
  background-color: #0078d6 !important;
}

.e-cell.e-highlightcustom.e-today.e-focused-date .e-day {
  background-color: rosybrown !important;
}

.e-cell.e-highlightcustom.e-today .e-day {
  background-color: rosybrown !important;
}

.e-cell.e-highlightcustom.e-today.e-focused-date .e-day {
  background-color: rosybrown !important;
}

.e-highlightcustom .e-day:hover {
  color: white !important;
  background-color: transparent !important;
}

.e-highlightspecial {
  background-color: darkslategray;
  color: white !important;
}

.e-highlightspecial .e-day {
  color: white !important;
}

.e-cell.e-highlightspecial.e-today.e-selected .e-day {
  background-color: #0078d6 !important;
}

.e-cell.e-highlightspecial.e-today.e-focused-date .e-day {
  background-color: darkslategray !important;
}

.e-cell.e-highlightspecial.e-today .e-day {
  background-color: darkslategray !important;
}

.e-cell.e-highlightspecial.e-today.e-focused-date .e-day {
  background-color: darkslategray !important;
}

.e-highlightspecial .e-day:hover {
  color: white !important;
  background-color: transparent !important;
}

.e-cal-icon.e-icons.e-add-new:before {
  content: "\e823";
}

.e-cal-icon.e-icons.e-edit:before {
  content: "\e944";
}

.e-cal-icon.e-icons.e-delete:before {
  content: "\eb00";
}

#edit-overlay {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  position: absolute;
  top: 0;
  z-index: 1004;
  left: 0;
}
#edit-overlay2 {
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.5);
  position: absolute;
  top: 0;
  z-index: 1006;
  left: 0;
}

.card.card-top-overlay {
  z-index: 1005;
}

.e-confirm-dialog.e-control.e-dialog.e-lib.e-dlg-modal.e-popup.e-popup-open {
  z-index: 1010 !important;
}

div.e-dlg-container.e-dlg-center-top {
  z-index: 1010 !important;
}
/*
div.e-dlg-overlay {
  z-index: 1009 !important;
  display: none;
}
*/
</style>
